import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';

export function Orders(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Order No.',
        accessor: 'orderNo',
        Cell: (c) => {
          //console.log(c)
          return (<SiteLink to={`/admin/order/${c.row.original.orderId}`}><b>{c.cell.value}</b></SiteLink>)
        }
      },
      {
        Header: 'Name',
        accessor: 'buyerName',
      },
      {
        Header: 'Email',
        accessor: 'buyerEmail',
      },
      {
        Header: 'Amount',
        accessor: 'totalAmount',
        Cell : (c) => "$" + c.cell.value
      },
      // {
      //   Header: 'Status',
      //   accessor: 'statusText',
      // },
      {
        Header: 'Order Date',
        accessor: 'orderDate',
        Cell: (c) => c.cell.value && utils.date.formatYYYYMMDD(c.cell.value)
      }
    ],
    []
  )

  // buyerEmail: "comsnack@gmail.com"
  // buyerName: "Joonchul Shin"
  // orderDate: "2020-05-21T19:36:27.7866282+00:00"
  // orderId: "2ad0c010-e4c7-4c5c-918e-0579a148f3e6"
  // orderNo: "FCCQ0001"
  // siteOrderSeqNo: 1
  // totalAmount: 1000
  // uniqueNo: "FCCQ"


  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + `/api/orderAdmin/getList`);
    // eslint-disable-next-line
  }, []);
  
  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()){
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  return (
    <>
      <h1>Orders</h1>
      <Table columns={columns} data={data} />
    </>
  );
}
